import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { BirdsnestProductGrid } from '../product/BirdsnestProductGrid';
import styles from './BirdsnestInfiniteScroll.module.scss';
export function BirdsnestInfiniteScroll({ products, loading, layout, mode = 'auto', hasMore = false, onLoadMore, merchandisingTiles = [], isModelView = true, meta, enrichedTvProductsById, trackingListId }) {
    const loaderRef = useRef(null);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    useEffect(() => {
        if (mode !== 'auto' || !hasMore || !onLoadMore || isLoadingMore || loading)
            return;
        const handleScroll = () => {
            if (!loaderRef.current)
                return;
            const rect = loaderRef.current.getBoundingClientRect();
            if (rect.top < window.innerHeight + 200 && !isLoadingMore) {
                setIsLoadingMore(true);
                onLoadMore();
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [mode, hasMore, onLoadMore, isLoadingMore, loading]);
    useEffect(() => {
        if (products.length > 0) {
            setIsLoadingMore(false);
        }
    }, [products.length]);
    const handleLoadMore = () => {
        if (onLoadMore && hasMore && !isLoadingMore && !loading) {
            setIsLoadingMore(true);
            onLoadMore();
        }
    };
    return (h("div", { class: styles.infiniteScrollContainer },
        h(BirdsnestProductGrid, { products: products, loading: loading && products.length === 0, meta: meta, layout: layout, merchandisingTiles: merchandisingTiles, isModelView: isModelView, enrichedTvProductsById: enrichedTvProductsById, trackingListId: trackingListId }),
        hasMore && mode === 'button' && (h("div", { class: styles.loadMoreButtonContainer },
            h("button", { class: styles.loadMoreButton, onClick: handleLoadMore, disabled: isLoadingMore || loading }, isLoadingMore || loading ? (h(Fragment, null,
                h("span", { class: styles.spinner }),
                "LOADING...")) : ('LOAD MORE PRODUCTS')))),
        hasMore && mode === 'auto' && (h("div", { ref: loaderRef, class: styles.autoLoadContainer }, (isLoadingMore || loading) ? (h("div", { class: styles.loadingIndicator },
            h("span", { class: styles.spinner }),
            h("p", { class: styles.loadingText }, "Loading more products..."))) : (h("div", { class: styles.scrollPrompt },
            h("p", null, "Scroll for more products")))))));
}
